var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    space: "preserve",
    serif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25934,0,0,1,-61.4248,15.6409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.763,
    y: 217.081,
    width: 190.541,
    height: 12.278,
    style: {
      fill: "rgb(128,128,128)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.71126e-17,1.25934,-1,6.12323e-17,234.381,-61.4248)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.763,
    y: 217.081,
    width: 190.541,
    height: 12.278,
    style: {
      fill: "rgb(128,128,128)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLForm);
export default __webpack_public_path__ + "static/media/l-form.a3fcb1790230ee9622a4aa3ea6c9d57f.svg";
export { ForwardRef as ReactComponent };